import {ContentDraftColumnData} from 'common/src/modules/contentFeeds/contentFeeds.types';
import normalizeDraftColumnValues from './normalizeDraftColumnValues';

function mergeDraftColumnValues(
  existing: Record<string, ContentDraftColumnData> | null | undefined,
  updates: Record<string, string> | null | undefined,
): Record<string, ContentDraftColumnData> | undefined {
  const normalized = normalizeDraftColumnValues(updates, existing);

  if (!normalized) {
    return existing ?? undefined;
  }

  return {
    ...(existing ?? {}),
    ...normalized,
  };
}

export default mergeDraftColumnValues;
